"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _underscore = require("../../utils/underscore");

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _UIButton = _interopRequireDefault(require("../../button/UIButton"));

var _UIClickable = _interopRequireDefault(require("../../button/UIClickable"));

var _ComponentWithWindowListeners = _interopRequireDefault(require("../../mixins/ComponentWithWindowListeners"));

var _UIIcon = _interopRequireDefault(require("../../icon/UIIcon"));

var _SyntheticEvent = _interopRequireDefault(require("../../core/SyntheticEvent"));

var _EventHandlers = require("../../core/EventHandlers");

var _UIControlledPopover = _interopRequireDefault(require("../../tooltip/UIControlledPopover"));

var _UIPopoverArrow = _interopRequireDefault(require("../../tooltip/UIPopoverArrow"));

var _UIDropdownCaret = _interopRequireDefault(require("../UIDropdownCaret"));

var CustomRenderer = _interopRequireWildcard(require("../../utils/propTypes/customRenderer"));

var _PlacementConstants = require("../../tooltip/PlacementConstants");

var _Tether = require("../../constants/Tether");

var _Functions = require("../../core/Functions");

var _iconName = require("../../utils/propTypes/iconName");

var _component = _interopRequireDefault(require("../../utils/propTypes/component"));

var _focusStylesListener = require("../../listeners/focusStylesListener");

var _decorators = require("../../utils/propTypes/decorators");

var _Timers = require("../../utils/Timers");

var _sizes = require("HubStyleTokens/sizes");

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var getArrowSize = function getArrowSize(buttonUse) {
  if (buttonUse.match(/link|transparent/)) {
    return 'medium';
  }

  return 'none';
};

var getPlacement = function getPlacement(placement, computedArrowSize) {
  if (placement) {
    return placement;
  } // Center if we have an arrow, otherwise flush left against the target


  if (computedArrowSize !== 'none') {
    return 'bottom';
  }

  return 'bottom right';
};

var getDistanceAdjustment = function getDistanceAdjustment(buttonSize, buttonUse) {
  if (buttonUse === 'transparent') {
    // Account for invisible padding
    var buttonPaddingY;

    if (buttonSize === 'extra-small') {
      buttonPaddingY = _sizes.BUTTON_XS_PADDING_Y;
    } else if (buttonSize === 'small') {
      buttonPaddingY = _sizes.BUTTON_SM_PADDING_Y;
    } else {
      buttonPaddingY = _sizes.BUTTON_DEFAULT_PADDING_Y;
    }

    return -parseInt(buttonPaddingY, 10);
  }

  return 0;
};

var getInsetAdjustment = function getInsetAdjustment(buttonUse, placement, computedArrowSize) {
  if (buttonUse === 'transparent' && placement === 'bottom right' && computedArrowSize === 'none') {
    // Account for invisible padding. Inset adjustments are applied twice
    // (once to the tether attachment, once to the target attachment), so
    // we halve our value here.
    return -parseInt(_sizes.BUTTON_DEFAULT_PADDING_X, 10) / 2;
  }

  return 0;
};

var getButtonClassName = function getButtonClassName(className, multiline, open, readOnly) {
  return (0, _classNames.default)(className, 'private-button__dropdown-opener', 'uiDropdown__button', {
    'private-button__dropdown-opener--multiline': multiline,
    'private-button__dropdown-opener--open': open,
    // a 'readonly' <button> doesn't make sense, so apply class for styling here
    'private-button--readonly': readOnly
  });
};

var getStyle = function getStyle(menuWidth, controlWidth) {
  return {
    width: menuWidth || controlWidth,
    minWidth: menuWidth === 'auto' ? controlWidth : null
  };
};

var renderButtonLabel = function renderButtonLabel(buttonText, iconName, readOnly) {
  var buttonClassNames = (0, _classNames.default)('private-dropdown__button-label', 'uiDropdown__buttonLabel', {
    'private-dropdown__button-label--no-icon': !iconName && !buttonText || readOnly
  });
  var icon = iconName ? _react.default.createElement(_UIIcon.default, {
    className: "private-dropdown__icon",
    name: iconName
  }) : null;
  return _react.default.createElement("span", {
    className: buttonClassNames
  }, icon, buttonText == null || buttonText === '' ? "\u200B" : buttonText);
};

var renderButton = function renderButton(_useNativeButton, ariaPressed, Button, buttonSize, buttonUse, open, rest, computedButtonClassName, buttonRef, dropdownId, handleButtonClick, handleKeyDown, renderedButtonLabel, renderedCaret, readOnly) {
  var ButtonType = Button || (buttonUse === 'unstyled' ? _UIClickable.default : _UIButton.default);
  var buttonProps = buttonUse === 'unstyled' ? {} : {
    _useNativeButton: _useNativeButton,
    size: buttonSize,
    use: buttonUse
  };
  return _react.default.createElement(ButtonType, (0, _extends2.default)({}, rest, buttonProps, {
    "aria-haspopup": true,
    "aria-owns": dropdownId,
    "aria-pressed": typeof ariaPressed === 'boolean' ? ariaPressed : open,
    className: computedButtonClassName,
    "data-dropdown-open": open,
    onClick: handleButtonClick,
    onKeyDown: handleKeyDown,
    buttonRef: buttonRef
  }), _react.default.createElement("span", {
    className: "uiDropdown__buttonContents private-dropdown__button__contents"
  }, renderedButtonLabel, !readOnly && renderedCaret));
};

var _default = _react.default.createClass({
  displayName: "UIAbstractDropdown",
  mixins: [_ComponentWithWindowListeners.default],
  propTypes: {
    animateOnMount: _react.PropTypes.bool.isRequired,
    animateOnToggle: _react.PropTypes.bool,
    'aria-pressed': _react.PropTypes.bool,
    arrowColor: _react.PropTypes.string,
    arrowSize: _react.PropTypes.oneOf(Object.keys(_UIPopoverArrow.default.ARROW_SIZES)),
    autoPlacement: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['horiz', 'vert'])]).isRequired,
    Button: _component.default,
    buttonSize: _UIButton.default.propTypes.size,
    buttonText: _react.PropTypes.node,
    buttonUse: _UIButton.default.propTypes.use,
    caretRenderer: CustomRenderer.propType,
    children: _react.PropTypes.node,
    closeOnOutsideClick: _react.PropTypes.bool,
    closeOnTargetLeave: _react.PropTypes.bool,
    Content: _component.default,
    disabled: _react.PropTypes.bool,
    dropdownClassName: _react.PropTypes.string,
    dropdownContentRef: (0, _decorators.hidden)(_react.PropTypes.func),
    iconName: (0, _iconName.getIconNamePropType)(),
    locked: _react.PropTypes.bool.isRequired,
    menuWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.oneOf(['auto'])]),
    minMenuWidth: _react.PropTypes.number.isRequired,
    multiline: (0, _decorators.hidden)(_react.PropTypes.bool.isRequired),
    onChangePlacement: _react.PropTypes.func,
    onFocusLeave: _react.PropTypes.func,
    onOpenChange: _react.PropTypes.func,
    onOpenComplete: _react.PropTypes.func,
    onOpenStart: _react.PropTypes.func,
    open: _react.PropTypes.bool.isRequired,
    pinToConstraint: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.arrayOf(_react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS_SIDES))]),
    placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS),
    popoverProps: _react.PropTypes.object,
    readOnly: _react.PropTypes.bool,
    _useMutationObserver: _react.PropTypes.bool,
    _useNativeButton: _react.PropTypes.bool
  },
  getDefaultProps: function getDefaultProps() {
    return {
      animateOnMount: false,
      autoPlacement: 'vert',
      buttonSize: 'default',
      buttonUse: 'secondary',
      caretRenderer: _react.default.createElement(_UIDropdownCaret.default, null),
      closeOnOutsideClick: true,
      dropdownClassName: '',
      locked: false,
      minMenuWidth: _Tether.MIN_MENU_WIDTH,
      multiline: false,
      open: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      controlWidth: 0
    };
  },
  componentWillMount: function componentWillMount() {
    this._id = (0, _underscore.uniqueId)('dropdown-');
    this._getStyle = (0, _memoizeOne.default)(getStyle);
    this._buttonRef = _react.default.createRef ? _react.default.createRef() : {
      current: null
    };
  },
  componentDidMount: function componentDidMount() {
    var open = this.props.open;

    if (open) {
      this.measureControlWidth();
      window.addEventListener('resize', this.handleWindowResize);
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    var open = this.props.open; // ⚠️ This condition prevents infinite loops! ⚠️

    if (prevState.controlWidth === this.state.controlWidth) {
      this.measureControlWidth();
    } // If the dropdown was closed via the keyboard, and the focus was within the dropdown, then give
    // keyboard focus to the control.


    if (prevProps.open && !open && this.hasKeyboardFocus() && (0, _focusStylesListener.isPageInKeyboardMode)()) {
      this.focusOnControl();
    }

    if (!prevProps.open && open) {
      window.addEventListener('resize', this.handleWindowResize);
    } else if (prevProps.open && !open) {
      window.removeEventListener('resize', this.handleWindowResize);
      (0, _Timers.cancelSchedulerCallback)(this._resizeFrame);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
    (0, _Timers.cancelSchedulerCallback)(this._resizeFrame);
  },
  measureControlWidth: function measureControlWidth() {
    // Make the menu width match up with the anchor width
    var open = this.props.open;
    var controlEl = this._buttonRef.current;

    if (controlEl && open) {
      var controlWidth = this.computeControlWidth(controlEl);

      if (controlWidth !== this.state.controlWidth) {
        this.setState({
          controlWidth: controlWidth
        });
      }
    }
  },
  getWindowListeners: function getWindowListeners() {
    return {
      click: this.handleWindowClick
    };
  },
  getWindowListenersActive: function getWindowListenersActive() {
    var _this$props = this.props,
        closeOnOutsideClick = _this$props.closeOnOutsideClick,
        open = _this$props.open;
    return closeOnOutsideClick && open;
  },
  hasKeyboardFocus: function hasKeyboardFocus() {
    var activeElement = document.activeElement;
    var dropdownNode = document.getElementById(this._id);

    if (!activeElement) {
      return false;
    }

    if (activeElement === this._buttonRef.current) {
      return true;
    } else if (dropdownNode && dropdownNode.contains(activeElement)) {
      return true;
    }

    return false;
  },
  handleButtonClick: function handleButtonClick(evt) {
    var _this$props2 = this.props,
        locked = _this$props2.locked,
        open = _this$props2.open,
        onClick = _this$props2.onClick;
    (0, _Functions.callIfPossible)(onClick, evt);

    if (!locked) {
      var nextOpen = !open;
      this.setIsOpen(nextOpen);
    }
  },
  handleWindowClick: function handleWindowClick(evt) {
    var target = evt.target; // Ignore clicks on DOM elements that are no longer in the document, as
    // these can represent "inside" clicks that caused DOM mutation.

    if (!document.body.contains(target)) {
      return;
    }

    var controlNode = this._buttonRef.current;
    if (!controlNode) return; // Ignore clicks on the button

    if (controlNode.contains(target)) {
      return;
    } // Ignore clicks on any <label> that contain the button


    var parentEl = controlNode;

    while (parentEl.parentElement) {
      parentEl = parentEl.parentElement;

      if (parentEl.tagName === 'LABEL' && parentEl.contains(target)) {
        return;
      }
    } // Ignore clicks on any <label> whose "for" attr points to the button


    var id = controlNode.id;

    if (id) {
      var labelsForControl = document.querySelectorAll("label[for=\"" + id + "\"]");

      for (var i = 0; i < labelsForControl.length; i++) {
        if (labelsForControl[i].contains(target)) {
          return;
        }
      }
    } // Ignore clicks within the dropdown


    var dropdownNode = document.getElementById(this._id);

    if (dropdownNode && (0, _EventHandlers.isClickWithinContainer)(evt, dropdownNode)) {
      return;
    }

    this.setIsOpen(false);
  },
  handleWindowResize: function handleWindowResize() {
    (0, _Timers.cancelSchedulerCallback)(this._resizeFrame);
    this._resizeFrame = (0, _Timers.requestSchedulerCallback)(this.measureControlWidth);
  },
  handleKeyDown: function handleKeyDown(evt) {
    // Handle keydown events from both the button and the dropdown
    var _this$props3 = this.props,
        onKeyDown = _this$props3.onKeyDown,
        open = _this$props3.open;

    if (open && evt.key === 'Escape') {
      this.setIsOpen(false);
      evt.stopPropagation();
    }

    (0, _Functions.callIfPossible)(onKeyDown, evt);
  },
  setIsOpen: function setIsOpen(nextOpen) {
    var _this$props4 = this.props,
        onOpenChange = _this$props4.onOpenChange,
        readOnly = _this$props4.readOnly;

    if (!onOpenChange || readOnly) {
      return;
    }

    onOpenChange((0, _SyntheticEvent.default)(nextOpen));
  },
  focusOnControl: function focusOnControl() {
    // When focusing, we want to avoid scrolling the page
    var _window = window,
        scrollX = _window.scrollX,
        scrollY = _window.scrollY;
    var controlNode = this._buttonRef.current;
    if (!controlNode) return;
    controlNode.focus();
    window.scrollTo(scrollX, scrollY);
  },
  reposition: function reposition() {
    if (this._popoverRef) {
      this._popoverRef.reposition();
    }
  },
  computeControlWidth: function computeControlWidth(controlEl) {
    var open = this.props.open;

    if (!controlEl || !open) {
      return 0;
    }

    var exactWidth = controlEl.getBoundingClientRect().width;
    var roundedWidth = window.chrome ? Math.floor(exactWidth) : exactWidth;
    return roundedWidth - 2; // account for 1px border added by UIPopover
  },
  popoverRefCallback: function popoverRefCallback(ref) {
    this._popoverRef = ref;
  },
  renderContent: function renderContent() {
    var _this$props5 = this.props,
        children = _this$props5.children,
        Content = _this$props5.Content,
        dropdownClassName = _this$props5.dropdownClassName,
        dropdownContentRef = _this$props5.dropdownContentRef,
        menuWidth = _this$props5.menuWidth,
        minMenuWidth = _this$props5.minMenuWidth;
    var controlWidth = Math.max(this.state.controlWidth, minMenuWidth);
    return _react.default.createElement("div", {
      className: (0, _classNames.default)('private-dropdown', 'uiDropdown__dropdown', dropdownClassName),
      id: this._id,
      onKeyDown: this.handleKeyDown,
      ref: dropdownContentRef,
      role: "presentation",
      style: this._getStyle(menuWidth, controlWidth)
    }, Content ? _react.default.createElement(Content, null) : children);
  },
  render: function render() {
    var _this$props6 = this.props,
        animateOnMount = _this$props6.animateOnMount,
        animateOnToggle = _this$props6.animateOnToggle,
        ariaPressed = _this$props6['aria-pressed'],
        arrowColor = _this$props6.arrowColor,
        arrowSize = _this$props6.arrowSize,
        autoPlacement = _this$props6.autoPlacement,
        Button = _this$props6.Button,
        buttonSize = _this$props6.buttonSize,
        buttonText = _this$props6.buttonText,
        buttonUse = _this$props6.buttonUse,
        caretRenderer = _this$props6.caretRenderer,
        __children = _this$props6.children,
        className = _this$props6.className,
        __closeOnOutsideClick = _this$props6.closeOnOutsideClick,
        closeOnTargetLeave = _this$props6.closeOnTargetLeave,
        __Content = _this$props6.Content,
        __dropdownClassName = _this$props6.dropdownClassName,
        __dropdownContentRef = _this$props6.dropdownContentRef,
        iconName = _this$props6.iconName,
        __locked = _this$props6.locked,
        __menuWidth = _this$props6.menuWidth,
        __minMenuWidth = _this$props6.minMenuWidth,
        multiline = _this$props6.multiline,
        onChangePlacement = _this$props6.onChangePlacement,
        __onClick = _this$props6.onClick,
        onFocusLeave = _this$props6.onFocusLeave,
        onOpenChange = _this$props6.onOpenChange,
        onOpenComplete = _this$props6.onOpenComplete,
        onOpenStart = _this$props6.onOpenStart,
        open = _this$props6.open,
        pinToConstraint = _this$props6.pinToConstraint,
        placement = _this$props6.placement,
        popoverProps = _this$props6.popoverProps,
        readOnly = _this$props6.readOnly,
        _useMutationObserver = _this$props6._useMutationObserver,
        _useNativeButton = _this$props6._useNativeButton,
        rest = (0, _objectWithoutProperties2.default)(_this$props6, ["animateOnMount", "animateOnToggle", "aria-pressed", "arrowColor", "arrowSize", "autoPlacement", "Button", "buttonSize", "buttonText", "buttonUse", "caretRenderer", "children", "className", "closeOnOutsideClick", "closeOnTargetLeave", "Content", "dropdownClassName", "dropdownContentRef", "iconName", "locked", "menuWidth", "minMenuWidth", "multiline", "onChangePlacement", "onClick", "onFocusLeave", "onOpenChange", "onOpenComplete", "onOpenStart", "open", "pinToConstraint", "placement", "popoverProps", "readOnly", "_useMutationObserver", "_useNativeButton"]);
    var computedArrowSize = arrowSize || getArrowSize(buttonUse);
    var computedButtonClassName = getButtonClassName(className, multiline, open, readOnly);
    var computedPlacement = getPlacement(placement, computedArrowSize);
    var computedDistanceAdjustment = getDistanceAdjustment(buttonSize, buttonUse);
    var computedInsetAdjustment = getInsetAdjustment(buttonUse, placement, computedArrowSize);
    var renderedButtonLabel = renderButtonLabel(buttonText, iconName, readOnly);
    var renderedCaret = CustomRenderer.render(caretRenderer, {
      use: buttonUse
    });
    return _react.default.createElement(_UIControlledPopover.default, (0, _extends2.default)({
      animateOnMount: animateOnMount,
      animateOnToggle: animateOnToggle,
      arrowColor: arrowColor,
      arrowSize: computedArrowSize,
      autoPlacement: autoPlacement,
      closeOnOutsideClick: false,
      closeOnTargetLeave: closeOnTargetLeave,
      Content: this.renderContent,
      _distanceAdjustment: computedDistanceAdjustment,
      _insetAdjustment: computedInsetAdjustment,
      _useMutationObserver: _useMutationObserver,
      onFocusLeave: onFocusLeave,
      onChangePlacement: onChangePlacement,
      onOpenChange: onOpenChange,
      onOpenStart: onOpenStart,
      onOpenComplete: onOpenComplete,
      open: open,
      pinToConstraint: pinToConstraint,
      placement: computedPlacement,
      ref: this.popoverRefCallback
    }, popoverProps), renderButton(_useNativeButton, ariaPressed, Button, buttonSize, buttonUse, open, rest, computedButtonClassName, this._buttonRef, this._id, this.handleButtonClick, this.handleKeyDown, renderedButtonLabel, renderedCaret, readOnly));
  }
});

exports.default = _default;
module.exports = exports.default;